/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * The styled components for Wizard Report
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.2.0
 */

import styled from 'styled-components';

import { CheckBoxContainerStyled } from '../../../../../components/common/Checkbox/styled/CheckboxStyled';
import { fonts } from '../../../../../theme';

export const WizardReportContainerStyled = styled.div`
    max-width: 385px;
`;

export const WizardReportTitleStyled = styled.div`
    ${fonts.textHeader3};
`;

export const WizardReportHeaderStyled = styled.div`
    ${fonts.textMainBold};
    margin-bottom: 16px;
`;

export const WizardReportParamLabelStyled = styled.label`
    display: block;
    margin-bottom: 12px;
    ${fonts.textMain};

    &:last-of-type {
        margin-bottom: 0;
    }

    ${CheckBoxContainerStyled} {
        position: relative;
        top: 2px;
        margin-right: 8px;
        width: 20px;
    }

    &:hover {
        cursor: pointer;
    }
`;
